export default __webpack_public_path__ + "static/media/element_35.157039e6.jpg";